<template>
  <mdb-container>

    <mdb-card class="mb-4">
      <mdb-card-header class="primary-color card-header">
        <mdb-row>
          <mdb-col class="text-left" col="4">
          <mdb-btn :disabled="executing" @click="doCancel" rounded size="sm">
            <mdb-icon icon="arrow-left"/>
            Back to Main
          </mdb-btn>
          </mdb-col>
          <mdb-col col="4">
            <h4 class="card-title mb-0">Attendance Taker</h4>
          </mdb-col>
          <mdb-col col="4">
          </mdb-col>
        </mdb-row>
      </mdb-card-header>
      <mdb-card-body>

        <mdb-tabs :active="0"
                  :links="[ {text:'Unknown'}, {text:'Present'}, {text: 'Canceled'}, {text: 'Canceled Late'}, {text: 'No Show'}]"
                  :transition-duration="0.5" card
                  class="mb-5"
                  tabs
                  transition-style="linear"
        >
          <attendance-tab :attendees="attendees" :event="event" :slot="'Unknown'" attendance="Unknown"/>
          <attendance-tab :attendees="attendees" :event="event" :slot="'Present'" attendance="Attended"/>
          <attendance-tab :attendees="attendees" :event="event" :slot="'Canceled'" attendance="Canceled"/>
          <attendance-tab :attendees="attendees" :event="event" :slot="'Canceled Late'" attendance="Late Cancel"/>
          <attendance-tab :attendees="attendees" :event="event" :slot="'No Show'" attendance="No Show"/>

        </mdb-tabs>
      </mdb-card-body>
    </mdb-card>
  </mdb-container>

</template>

<script>
import AttendanceTab from "./AttendanceTab";
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbRow,
  mdbTabs
} from 'mdbvue';

export default {
  name: 'Event-Attendance-Editor',
  components: {
    AttendanceTab,
    mdbBtn,
    mdbIcon,
    mdbInput,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbContainer,
    mdbBadge,
    mdbTabs
  },
  props: {
    event: {
      type: Object,
      default: []
    },
    attendees: {
      type: Array,
      default: []
    }
  },
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    },
    group() {
      return this.$store.state.currentGroup
    },
    executing() {
      return this.$store.state.executing
    },
    settings() {
      return this.$store.state.settings
    }
  },
  data() {
    return {
      saveAction: null,
      saveHost: null,
      stillGoing: false,
      memberModalId: null,
      rsvpModal: false,
      currentMember: null
    }
  },
  methods: {
    change(m) {
      this.currentMember = m
      this.rsvpModal = true
    },
    rsvpChanged: function () {
      this.rsvpModal = false
      this.$store.dispatch("setExecuting", false)
      api.get("/reservation/details/" + this.event.eventId + "/?member=" + this.currentMember.id).then(
        (results) => {
          for (let i = 0; i < this.attendees.length; i++) {
            let a = this.attendees[i]
            if (a.id == results.data.id) {
              a.guests = results.data.guests
              a.badge = results.data.badge
              a.badgeType = results.data.badgeType
              a.updated = results.data.updated
              a.balance = results.data.balance
              a.charged = results.data.charged
            }
          }
          this.currentMember = null
        },
        (error) => {
          this.$notify.error({message: "Could not load rules. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    rsvpCanceled: function () {
      this.rsvpModal = false
      this.currentMember = null
    },
    showMember: function (host) {
      if (this.group.role == "Public") return;
      this.memberModalId = host.id
    },

    doCancel() {
      this.$emit("cancel")
    },
    modalClosed() {
      this.memberModalId = null
    },
    waitlist(member, newRec) {
      this.$store.dispatch("setExecuting", true);
      api.post('/reservation/adminWaitlist/' + this.event.eventId + "/?member=" + member.id, {}).then(
        (results) => {
          member.status = "Waiting"
          member.badge = "Waiting"
          member.badgeType = "warning"
          if (newRec) {
            this.attendees.unshift(results.data)
            this.memberList = []
            this.query = ""
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      });

    },
    notGoing(member) {
      this.$store.dispatch("setExecuting", true);
      api.post('/reservation/adminNotGoing/' + this.event.eventId + "/?member=" + member.id, {}).then(
        (results) => {
          let loc = this.attendees.indexOf(member)
          this.attendees.splice(loc, 1)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      });

    },
    going(member, newRec) {
      this.$store.dispatch("setExecuting", true);
      api.post('/reservation/adminGoing/' + this.event.eventId + "/?member=" + member.id, {}).then(
        (results) => {
          member.status = this.$t('page.event.going')
          member.badge = ""
          member.badgeType = ""
          if (newRec) {
            this.attendees.unshift(results.data)
            this.memberList = []
            this.query = ""
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      });

    },
  }
}
;
</script>
<style scoped>
p {
  line-height: 1em;
  margin-bottom: 5px;
}

.profile-card {
  margin-top: 100px;
}

.profile-card .avatar {
  max-width: 150px;
  max-height: 150px;
  margin: -70px auto 0;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  overflow: hidden;
}

.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
}

.cascading-admin-card .admin-up .fa {
  padding: 1.7rem;
  font-size: 2rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  -webkit-border-radius: 3px;
  border-radius: 3px;
}

.cascading-admin-card .admin-up .fa, .z-depth-2 {
  -webkit-box-shadow: 0 8px 17px 0 rgba(0, 0, 0, .2), 0 6px 20px 0 rgba(0, 0, 0, .19);
  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, .2), 0 6px 20px 0 rgba(0, 0, 0, .19);
}

.badge-container {
  position: absolute;
  right: 0;
}

</style>
